<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
            </div>

            <!-- <label for="voucher" class="col-sm-1 control-label">Voucher</label> -->
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button type="submit" @click.prevent="searchChallan"
                      class="p-button-raised" label="Search" icon="pi pi-search"/>
              <!-- <button type="submit" style="margin-left:10px" v-if="this.purchaseChallanList.length > 0"  @click.prevent="reset"
              class="btn btn-info pull-left">Reset</button> -->
            </div>
          </div>
        </form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <a href="#" @click.prevent="exportCSV()" v-if="this.purchaseChallanLists.length > 0 && this.$store.getters.modules.includes('5.38')">
              <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
            </a>
            <DataTable :value="purchaseChallanLists"
                       :paginator="true" ref="po"
                       :rowsPerPageOptions="[100,500,1000]"
                       :rows="100" :filters="filters"
                       class="p-datatable-responsive p-datatable-gridlines"
                       data-key="id"
                       :selection.sync="selectedProduct1" selectionMode="single">
              <Column header="S.N">
                <template #body="sl">
                  {{ sl.index + 1 }}
                </template>
              </Column>
              <Column header="Miti" headerStyle="width:8em;" :sortable="true"
                      field="purchaseSalesDateNepali" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDateNepali']"/>
                </template>
              </Column>
              <Column header="Date" headerStyle="width:8em;" :sortable="true" field="purchaseDate"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseDate']"/>
                </template>
              </Column>
              <Column header="Challan No" :sortable="true" field="challanNo" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['challanNo']"/>
                </template>
              </Column>
              <Column header="Supplier" :sortable="true" field="accountName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
                </template>

                <template #footer>
                  Total:
                </template>
              </Column>
              <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
                </template>
              </Column>
              <Column header="Store" :sortable="true" field="warehouse.name" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['warehouse.name']"/>
                </template>
              </Column>
              <Column header="Sub Total" bodyStyle="text-align: right" :sortable="true" field="subTotalAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['subTotalAmount']"/>
                </template>

                <template #footer>
                  {{ totalSubAmount.toFixed(2) }}
                </template>
                
              </Column>
              <Column header="Non-taxable" bodyStyle="text-align: right" :sortable="true" field="nonTaxableAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['nonTaxableAmount']"/>
                </template>
                <template #footer>
                  {{ totalNonTaxableAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Taxable" bodyStyle="text-align: right" :sortable="true" field="taxableAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['taxableAmount']"/>
                </template>
                <template #footer>
                  {{ totalTaxableAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Vat" bodyStyle="text-align: right" :sortable="true" field="vatAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['vatAmount']"/>
                </template>
                <template #footer>
                  {{ totalVatAmount.toFixed(2) }}
                </template>
              </Column>

              <Column header="Total" bodyStyle="text-align: right" :sortable="true" field="totalBillAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['totalBillAmount']"/>
                </template>
                <template #footer>
                  {{ totalSumBillAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Action" headerStyle="width:11em;">
                <template #body="slotProps">
                  <Button icon="pi pi-pencil" v-if="enableEdit"  v-tooltip.top="'Edit'"
                          class="p-button-raised p-button-success"
                          @click.prevent="editPurchaseChallan(slotProps.data)"/>
                  <Button icon="pi pi-pencil" v-else disabled class="p-button-raised p-button-success" v-tooltip.top="'Edit'"
                          @click.prevent="editPurchaseChallan(slotProps.data)"/>

                  <Button v-if="enableDelete" class="p-button-raised p-button-danger" v-tooltip.top="'Delete'"
                          @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
                  <Button v-else disabled class="p-button-raised p-button-danger" icon="pi pi-trash" v-tooltip.top="'Delete'"
                          @click="openDialog(slotProps.data.id)"/>

                  <Button class="p-button-raised" icon="pi pi-eye" v-tooltip.top="'View Details'"
                          @click="viewPIVDetail(slotProps.data)"/>
                  <Button class="p-button-raised p-button-warning" v-tooltip.top="'Print'"
                          @click="exportToPdf(slotProps.data.id)"
                          icon="pi pi-print"/>
                </template>
              </Column>
              <template #empty>No record found</template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'

export default {
  name: 'purchaseChallanReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      purchaseChallanList: [],
      loading: false,
      dialogShow: false,
      columnList: '',
      englishDateEnabled: true,
      filters: {},
      enableEdit: false,
      enableDelete: false,
      selectedProduct1: null,
      totalSubAmount: 0,
      totalNonTaxableAmount: 0,
      totalTaxableAmount: 0,
      totalVatAmount: 0,
      totalSumBillAmount: 0,
      totalDiscountAmount: 0
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.checkEnableEdit()
    this.checkEnableDelete()
  },
  computed: {
    purchaseChallanLists() {
      return this.$store.state.purchase.purchaseChallanLists
    }
  },
  methods: {
    async searchChallan() {
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadpurchaseChallanLists', dat)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      } else {
        this.purchaseChallanList = resp.data.data
        this.totalBalance()
      }
    },
    async viewPIVDetail(data) {
      let PIHdata = {
        id: data.id,
        warehouse: data.warehouse,
        account: data.accountMaster,
        purchaseDate: data.purchaseSalesDateNepali,
        challanNo: data.challanNo,
        reportType: data.reportType,
        referenceNumber: data.referenceNumber,
        vatTypeEnum: data.vatTypeEnum,
        remarks: data.remarks
      }
      this.$router.push({name: 'purchase Detail Report', params: {purchaseHeaderObj: PIHdata}})
    },
    checkEnableEdit() {
      if (this.$store.getters.modules.includes(',5.07')) {
        this.enableEdit = true
      }
    },
    totalBalance() {
      this.totalSubAmount = 0.0
      this.totalNonTaxableAmount = 0.0
      this.totalTaxableAmount = 0.0
      this.totalVatAmount = 0.0
      this.totalSumBillAmount = 0.0
      for (let sale of this.purchaseChallanList) {
        this.totalSubAmount += sale.subTotalAmount
        this.totalNonTaxableAmount += sale.nonTaxableAmount
        this.totalTaxableAmount += sale.taxableAmount
        this.totalVatAmount += sale.vatAmount
        this.totalSumBillAmount += sale.totalBillAmount
      }
    },
    checkEnableDelete() {
      if (this.$store.getters.modules.includes(',5.11')) {
        this.enableDelete = true
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/purchaseChallan' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'purchaseChallan.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printPurchaseBill/' + SOHeaderId + '/purchaseChallan' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'purchaseChallan.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    async editPurchaseChallan(data) {
      this.$router.push({name: 'Purchase Challan', params: {purchaseChallan: data}})
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        inventoryInHeaderId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deletePurchaseChallan', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.dialogShow = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.dialogShow = false
      }
    },
    cancel(data) {
      this.dialogShow = false
      this.show = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      this.purchaseChallanList = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    InputMask,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// purchaseChallanReport.vue?0ad33bdb